import Module from '../components/ui/Card'

interface OfflineProps {
	refresh: any
}

const Offline = ({ refresh }: OfflineProps) => (
	<div className="flex h-screen w-screen items-center justify-center">
		<div className="w-full text-center">
			<Module className="w-9/10 mx-auto max-w-[550px] px-4 py-12 text-center">
				<div className="mb-4 flex justify-center">
					<h1 className="my-auto pl-4 text-[4rem] font-semibold text-slate-400">Oops!</h1>
				</div>
				<h3 className="text-4xl font-semibold text-slate-700">No internet</h3>
				<p className="py-6">Slow or no internet connection. Please check your internet settings.</p>
			</Module>
		</div>
	</div>
)

export default Offline
